import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { xeroQueryKeys } from "./xeroQueryKeys";

export const useMutationXeroEnableIntegration = ({ api }: { api: ApiType }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => await api.xeroApi.enableIntegration(),
    onSuccess: async () =>
      await queryClient.invalidateQueries({ queryKey: xeroQueryKeys.all() }),
  });
};
